import { render, staticRenderFns } from "./jl.vue?vue&type=template&id=6456b47e&scoped=true&"
import script from "./jl.vue?vue&type=script&lang=js&"
export * from "./jl.vue?vue&type=script&lang=js&"
import style0 from "./jl.vue?vue&type=style&index=0&id=6456b47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456b47e",
  null
  
)

export default component.exports